function checkStatus(response) {
  if (response.status < 200 || response.status >= 300) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

function readCookie(cookieName) {
  const name = `${cookieName}=`;
  const cookies = decodeURIComponent(document.cookie).split(';');
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

export default function api(dispatch, url, method, body, receiver, onError) {
  return fetch(url, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Csrf-Token': readCookie('CSRF_TOKEN')
    },
    credentials: 'include',
    method,
    body
  })
    .then(checkStatus)
    .then(response => {
      if (method === 'DELETE' || response.status === 204) {
        return response
          .blob() // response.json() chokes if response has no body
          .then(() => dispatch(receiver({})));
      }
      return response.json().then(json => {
        dispatch(receiver(json));
      });
    })
    .catch(error => {
      console.error(`Request failed ${error}`);
      dispatch(receiver(null, error));
      if (onError) {
        onError(error);
      }
    });
}
